import { Balance, BalanceAlias } from '@/api/models/finance'

export const shouldShowInvoices = (balance: Balance) => {
  return (
    balance.debtSum > 0 || balance.alias === BalanceAlias.ComplementaryServices
  )
}
